import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import LocalService from '../../../../../../services/local-auth';
import { Link } from 'react-router-dom';
import '../../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [secretaria, setSecretaria] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchLocais()
            setNome("")
            setSecretaria("")
        } else {
            var response = await LocalService.buscar(query)
            if (response.data.length >= 1) {
                props.setLocs(response.data)
                props.setVazio(false)
                setNome("")
                setSecretaria("")
            } else {
                props.setVazio(true)
                setNome("")
                setSecretaria("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome !== "false" && nome != "false" && nome !== "") prepQuery = prepQuery + `&nome=${encodeURI(nome)}`;
        if (secretaria !== "false" && secretaria != "false" && secretaria !== "") prepQuery = prepQuery + `&secretaria=${encodeURI(secretaria)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={2}>
                    <Col xs={12} lg={10}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Nome do Local"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Secretaria">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {props.secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/institucional/locais'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
